import UpgradeDialogModal from './src/UpgradeDialogModal.vue';
import { createApp, type App } from 'vue';
import { createI18n } from 'vue-i18n';
import { getCurrentLanguage } from '@eureka/language-tool';
import { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';
import { openClueReport } from '../clue-report';
import { controlDeferred } from '@eureka/utils/control.js';
import { checkJpEnv } from '@eureka/utils/check-jp-env.js';

const i18n = createI18n({
    legacy: false,
    locale: getCurrentLanguage(),
    fallbackLocale: 'en',
    messages: {},
});

let isFeatureUpgradeDialogOpen = false;

/**
 * 仅供plg用户使用
 * @returns
 */
export const openFeatureUpgradeDialog = async(params?: { eventDetail?: Record<string, any> }) => {
    if (isFeatureUpgradeDialogOpen) { return }
    isFeatureUpgradeDialogOpen = true;
    const isJPEnv = checkJpEnv()
    const { isLsPlg, ls_plg_role } = await controlDeferred.promise;
    if (!isLsPlg) { return }
    if (isJPEnv) {
        openClueReport({
            pkgType: EurekaPackageType.LS_COMMERCIAL,
            version: 'LS_PLG',
        });
        isFeatureUpgradeDialogOpen = false;
        return;
    }

    const div = document.createElement('div');
    div.setAttribute('data-theme', 'patsnapRD');
    document.body.appendChild(div);

    const unmountApp = (app: App) => {
        app.unmount();
        document.body.removeChild(div);
    };

    const promise = new Promise<boolean | undefined>((resolve) => {
        const app = createApp(UpgradeDialogModal, {
            role: ls_plg_role,
            eventDetail: params?.eventDetail,
            callback: () => {
                resolve(true);
                unmountApp(app);
                isFeatureUpgradeDialogOpen = false;
            },
        });
        app.use(i18n);
        app.mount(div);
    });

    return promise;
}
